import React, { useState } from 'react';
import { PlusIcon, EyeIcon, SettingsIcon } from 'lucide-react';
export function PortalBuilder() {
  const [portals, setPortals] = useState([{
    id: 1,
    name: 'Acme Corp Portal',
    domain: 'acme.gtm.zoominfo.com',
    status: 'active',
    customers: 12,
    lastUpdated: '2024-01-15'
  }, {
    id: 2,
    name: 'TechStart Portal',
    domain: 'techstart.gtm.zoominfo.com',
    status: 'active',
    customers: 8,
    lastUpdated: '2024-01-10'
  }]);
  return <div className="max-w-7xl mx-auto" data-id="element-2608">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg p-6 mb-6 text-white" data-id="element-2609">
        <h2 className="text-2xl font-bold mb-2" data-id="element-2610">White-Label Portal Builder</h2>
        <p className="text-blue-100" data-id="element-2611">
          Create branded GTM portals for your customers
        </p>
        <button className="mt-4 flex items-center gap-2 px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2612">
          <PlusIcon className="w-4 h-4" data-id="element-2613" />
          Create New Portal
        </button>
      </div>
      {/* Existing Portals */}
      <div data-id="element-2614">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2615">
          Your Portals
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2616">
          {portals.map(portal => <div key={portal.id} className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-shadow" data-id="element-2617">
              <div className="flex items-start justify-between mb-4" data-id="element-2618">
                <div data-id="element-2619">
                  <h4 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-2620">
                    {portal.name}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2621">{portal.domain}</p>
                </div>
                <span className="px-2 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full" data-id="element-2622">
                  {portal.status}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4 p-3 bg-gray-50 rounded-lg" data-id="element-2623">
                <div data-id="element-2624">
                  <p className="text-xs text-gray-600 mb-1" data-id="element-2625">Customers</p>
                  <p className="text-lg font-bold text-gray-900" data-id="element-2626">
                    {portal.customers}
                  </p>
                </div>
                <div data-id="element-2627">
                  <p className="text-xs text-gray-600 mb-1" data-id="element-2628">Last Updated</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-2629">
                    {new Date(portal.lastUpdated).toLocaleDateString()}
                  </p>
                </div>
              </div>
              <div className="flex gap-2" data-id="element-2630">
                <button className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium" data-id="element-2631">
                  <EyeIcon className="w-4 h-4" data-id="element-2632" />
                  Preview
                </button>
                <button className="flex items-center justify-center gap-2 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium" data-id="element-2633">
                  <SettingsIcon className="w-4 h-4" data-id="element-2634" />
                </button>
              </div>
            </div>)}
        </div>
      </div>
      {/* Portal Features */}
      <div className="mt-8 bg-white rounded-lg border border-gray-200 p-6" data-id="element-2635">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2636">
          Portal Features
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2637">
          <div className="p-4 bg-blue-50 rounded-lg" data-id="element-2638">
            <h4 className="font-semibold text-blue-900 mb-2" data-id="element-2639">
              Custom Branding
            </h4>
            <p className="text-sm text-blue-700" data-id="element-2640">
              Logo, colors, and domain customization
            </p>
          </div>
          <div className="p-4 bg-purple-50 rounded-lg" data-id="element-2641">
            <h4 className="font-semibold text-purple-900 mb-2" data-id="element-2642">
              User Management
            </h4>
            <p className="text-sm text-purple-700" data-id="element-2643">
              Control access and permissions
            </p>
          </div>
          <div className="p-4 bg-green-50 rounded-lg" data-id="element-2644">
            <h4 className="font-semibold text-green-900 mb-2" data-id="element-2645">
              Analytics Dashboard
            </h4>
            <p className="text-sm text-green-700" data-id="element-2646">Track usage and engagement</p>
          </div>
        </div>
      </div>
    </div>;
}